#import "../fragments/tag-count-fragment.graphql"

query GetTags($input: TagsQueryInputType!) {
    tags(input: $input) {
        totalCount
        pageInfo {
            __typename
            endCursor
            hasNextPage
            startCursor
            hasPreviousPage
        }
        edges {
            node {
                ...TagCount
            }
        }
    }
}
